module.exports = __webpack_public_path__ + "img/Background_SMVS.2928a016.png";